import * as S from "../ConvenienceTest.style";
import { useContext, useEffect, useState } from "react";
import Moment from "moment";
import UserIdentitiesService, { AccessRequestDto, UserIdentityType } from "../../../services/UserIdentitiesService";
import SavingsPlans, { SavingsPlanType } from "../../../services/SavingsPlanService";
import Auth from "../../../Auth/Auth";
import { useHistory, useParams } from "react-router-dom";
import { DefaultButton, Spinner, SpinnerSize } from "@fluentui/react";
import scrollToTop from "../../../utils/scrollToTop";
import React from "react";
import SavingsPlanService from "../../../services/SavingsPlanService";
import DocumentTitle from "react-document-title";
import { ThemeContext } from '@fluentui/react-theme-provider';
import CustomIcon from "../../icons/CustomIcon";
import { ModalWithCancel } from "../../Modals/ModalWithCancel";
import ModalRequestAuthorization from "../ModalRequestAuthorization/ModalRequestAuthorization";
import { UserIndentityStatusEnum } from "../../types/UserIdentity.Status";


const ConvenienceTestAccountHolder = () => {
	const history = useHistory();
	const theme = useContext(ThemeContext);
	const [error, setError] = useState({ status: false, message: "" });
	const [size, setSize] = useState(window.innerWidth);
	const [savingsPlan, setSavingsPlan] = useState<SavingsPlanType>();
	const [userIdentities, setUserIdentities] = useState<UserIdentityType[]>([]);
	const [isLoaded, setIsLoaded] = useState(false);
	const user = Auth.getUserProfile();
	const { savingsPlanId } = useParams<any>();
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [deleteId, setDeleteId] = useState<number | null>(null);
	const [deleteUserName, setDeleteUserName] = React.useState<string>("");


	// modal de autorización
	const [showRequestAuthorizationModal, setShowRequestAuthorizationModal] = useState<boolean>(false);
	const [userIdentitiesAccessRequest, setUserIdentitiesAccessRequest] = useState<AccessRequestDto[]>([]);
	const [selectedUserIdentity, setSelectedUserIdentity] = useState<UserIdentityType>();
	

	useEffect(() => {
		scrollToTop();
	}, []);

	useEffect(() => {
		window.addEventListener("resize", () => setSize(window.innerWidth));
	}, []);

	useEffect(() => {
		SavingsPlans.getSavingsPlan(savingsPlanId).then(
			(data: SavingsPlanType) => {
				setSavingsPlan(data);
			},
			error => {
				setError(error);
			}
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	useEffect(() => {
		const fetchData = async () => {
			try {
				setIsLoaded(false);
	
				// Paso 1: Obtener los UserIdentities de la tabla UserIdentity
				const userIdentities = await UserIdentitiesService.getIdentitiesByUserId(user.id);
				setUserIdentities(userIdentities);
	
				// Paso 2: Obtener las solicitudes de acceso en la tabla AccessRequest
				// const accessRequestResponse = await UserIdentitiesService.getAllAccessRequestsByUserId(user.id);
	
				// if (accessRequestResponse.status === 200 && accessRequestResponse.count > 0) {
				// 	// Mapear los nuevos UserIdentities desde accessRequestResponse
				// 	const accessIdentities  = accessRequestResponse.data.map((accessRequest: AccessRequestDto) => ({
				// 		id: accessRequest.targetUserIdentity?.id!,
				// 		firstName: accessRequest.targetUserIdentity?.firstName!,
				// 		lastName: accessRequest.targetUserIdentity?.lastName!,
				// 		secondLastName: accessRequest.targetUserIdentity?.secondLastName!,
				// 		email: accessRequest.targetUserIdentity?.email!,
				// 		birthday: accessRequest.targetUserIdentity?.birthday!,
				// 		fromAccessRequest: true,
				// 		showAuthorizationIcon: (user.id !== accessRequest.requestingUserId) ? true : false
				// 	} as UserIdentityType));

				// 	// filtrado de datos para el modal
				// 	const filteredAccessRequests = filterAccessByRequestedUserIdentityId(accessRequestResponse.data, user.id);
				// 	// modal de autorizaciones
				// 	setUserIdentitiesAccessRequest(filteredAccessRequests);
	
					// // Acumular en el estado los userIdentities
					// setUserIdentities(prev => [...prev, ...accessIdentities]);
				// }
			} catch (error: any) {
				setError(error);
			} finally {
				setIsLoaded(true);
			}
		};
	
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	const filterAccessByRequestedUserIdentityId = (accessRequest: AccessRequestDto[], mainUserIdentityId: Number) => {
		const filteredAccessRequests = accessRequest.filter(
			(accessRequest: AccessRequestDto) => accessRequest.requestedUserIdentity?.id === mainUserIdentityId
		);
		
		return filteredAccessRequests;
	};
	

	const fullName = (identity: UserIdentityType) => {
		var fullName = "";
		if (identity.firstName !== undefined && identity.firstName !== "") {
			fullName = identity.firstName;
		}
		if (identity.lastName !== undefined && identity.lastName !== "") {
			fullName += " " + identity.lastName;
		}
		if (identity.secondLastName !== null && identity.secondLastName !== "") {
			fullName += " " + identity.secondLastName;
		}
		return fullName;
	};

	const handleAuthorizationIconClick = (userIdentity: UserIdentityType) => {
		// setShowRequestAuthorizationModal(true);
		// setSelectedUserIdentity(userIdentity);
	};

	const redirectToMap = () => {
		history.push("/configurationMap", {
			savingPlanId: savingsPlan?.id,
			savingPlanName: savingsPlan?.name
		});
	};

	const confirmDeleteAccountHolder = (userIdentity: UserIdentityType) => {
		setDeleteId(userIdentity?.id!);
		setDeleteUserName(`${userIdentity.firstName} ${userIdentity.lastName} ${userIdentity.secondLastName}`);
		setShowDeleteModal(true);
	};

	const deleteAccountHolder = (userIdentityId: number | null) => {
		if (userIdentityId !== null) {
			UserIdentitiesService.deleteUserIdentity(userIdentityId).then(
				() => {
					UserIdentitiesService.getIdentitiesByUserId(user.id).then(
						(userIdentities: UserIdentityType[]) => setUserIdentities(userIdentities),
						(error) => setError(error)
					);
				},
				(error: any) => setError(error)
			);
		}
	};

	const continueToNextStep = () => {
		var nextStep = "2.3";
		if (savingsPlan !== undefined && [0, 1].includes(savingsPlan.type)) {
			nextStep = "2.2";
		}
		SavingsPlanService.patchSavingsPlan(savingsPlanId, { configurationMapStep: nextStep }).then(
			() => {
				redirectToMap();
			},
			(error: any) => {
				setError(error);
			}
		);
	};

	return (
		<DocumentTitle title={`IronIA - Intervinientes ${savingsPlan?.name !== undefined ? "- " + savingsPlan.name : ""}`}>
			<React.Fragment>
				<S.HelperStyle />
				<S.Cont theme={theme}>
					<S.MainCont>
						<S.Steps>
							<h3>
								Paso 1 <span>de 2</span>
							</h3>
						</S.Steps>
						<S.Title>
							<h1>Interviniente</h1>
							<h2>Aquí puedes gestionar los distintos tipos de intervinientes de tus planes de cartera.</h2>
						</S.Title>
						<S.BarCont>
							<S.BgBar />
							<S.ProsBar />
						</S.BarCont>
						{userIdentities !== undefined && (
							<S.TabletCont theme={theme}>
								{size > 899 ? (
									<S.Table>
										<tbody>
											<tr>
												<th>Nombre y apellidos</th>
												<th>Correo electrónico</th>
												<th className="tight">Menor de edad</th>
												<th className="tight">Conocer a nuestro cliente</th>
												<th className="tight"></th>
											</tr>
											{userIdentities.length > 0 &&
												userIdentities.map((userIdentity: UserIdentityType, index: number) => {
													var currentDate = Moment();
													var birthdayDate = Moment(userIdentity.birthday);
													var isMinor = currentDate.diff(birthdayDate, "years") < 18;
													return (
														<tr key={"index" + index}>
															<td>{userIdentity.firstName ? fullName(userIdentity) : user.fullName}</td>
															<td>{userIdentity.email ? userIdentity.email : user.email}</td>
															<td className="text-center">{isMinor ? "Sí" : "No"}</td>
															<td className="text-center">
																{userIdentity.status !== undefined && userIdentity.status === UserIndentityStatusEnum.New && <span>No</span>}
																{userIdentity.status !== undefined &&
																	["PENDING", "ACTIVE", "OUTDATED", "CANCELLED"].includes(userIdentity.status) && (
																		<span>Sí</span>
																	)}
															</td>
															<td className="actions">
																<CustomIcon
																	iconName="Edit"
																	size="17"
																	color="#CC214F"
																	paddingTop="10%"
																	onClick={() => history.push("/accountHolderData/" + savingsPlanId + "/" + userIdentity.id)}
																/>
																
																{(userIdentity.main === false && userIdentity.fnmContractsUserIdentities?.length === 0) ? (
																	<CustomIcon
																		iconName="Delete"
																		size="17"
																		color="#CC214F"
																		paddingTop="10%"
																		onClick={() => confirmDeleteAccountHolder(userIdentity)}
																	/>
																) : (
																	<div style={{ width: "17px" }} />
																)}

																{/* {userIdentity.fromAccessRequest && ( */}
																{/* {false && (
																	<>
																		{userIdentity.showAuthorizationIcon ? (
																			<div style={{ width: "100%", display: "flex", justifyContent: "flex-start", alignItems: "center" }}>
																				<AuthorizationIcon 
																					className="authorization-icon" 
																					onClick={() => handleAuthorizationIconClick(userIdentity)} 
																				/>
																			</div>
																			
																		) : (
																			<span style={{marginTop: "2px", marginLeft: "-17px", fontSize:"12px", fontWeight:"600", color: "#cc214f"}}>{userIdentitiesAccessRequest[0]?.status!}</span>
																		)}
																	</>
																)} */}
															</td>
														</tr>
													);
												})}
										</tbody>
									</S.Table>
								) : (
									<React.Fragment>
										{userIdentities.length > 0 && (
											<S.Table>
												<tbody></tbody>
												{userIdentities.forEach((userIdentity: UserIdentityType, index: number) => {
													var currentDate = Moment();
													var birthdayDate = Moment(userIdentity.birthday);
													var isMinor = currentDate.diff(birthdayDate, "years") < 18;
													return (
														<tbody key={"index" + index}>
															<tr>
																<th>Nombre y apellidos</th>
																<td>{userIdentity.firstName ? fullName(userIdentity) : user.fullName}</td>
															</tr>
															<tr>
																<th>Correo electrónico</th>
																<td>{userIdentity.email ? userIdentity.email : user.email}</td>
															</tr>
															<tr>
																<th className="tight">Menor de edad</th>
																<td className="text-center">{isMinor ? "Sí" : "No"}</td>
															</tr>
															<tr>
																<th className="tight">Conocer a nuestro cliente</th>
																<td className="text-center">
																	{userIdentity.status !== undefined && userIdentity.status === UserIndentityStatusEnum.New && <span>No</span>}
																	{userIdentity.status !== undefined &&
																		["PENDING", "ACTIVE", "OUTDATED", "CANCELLED"].includes(userIdentity.status) && (
																			<span>Sí</span>
																		)}
																</td>
															</tr>
															<tr>
																<th className="tight"></th>
																<td>
																	<DefaultButton
																		className="button mini-primary-button"
																		onClick={() =>
																			history.push("/accountHolderData/" + savingsPlanId + "/" + userIdentity.id)
																		}
																	>
																		Editar
																	</DefaultButton>
																</td>
															</tr>
														</tbody>
													);
												})}
											</S.Table>
										)}
									</React.Fragment>
								)}
								{!isLoaded && (
									<div className="ms-Grid-row">
										<Spinner size={SpinnerSize.large} />
									</div>
								)}
								<div className="ms-Grid-row">
									{userIdentities.length === 1 && userIdentities[0]?.status === UserIndentityStatusEnum.New && (
										<div className="ms-Grid-col mt20">
											<DefaultButton
												className="button tiny-secondary-button"
												onClick={() => history.push("/accountHolderData/" + savingsPlanId + "/" + userIdentities[0].id)}
											>
												Completar datos
											</DefaultButton>
										</div>
									)}
									{(userIdentities.length > 1 || (userIdentities.length === 1 && userIdentities[0]?.status !== UserIndentityStatusEnum.New )) && (
										<div className="ms-Grid-col mt20">
											<DefaultButton
												className="button tiny-secondary-button"
												onClick={() => history.push("/accountHolderData/" + savingsPlanId)}
											>
												Añadir intervinientes para esta cuenta
											</DefaultButton>
										</div>
									)}
								</div>
							</S.TabletCont>
						)}
						{(userIdentities.length > 1 || (userIdentities.length === 1 && userIdentities[0]?.status !== UserIndentityStatusEnum.New )) &&
							savingsPlan?.configurationMapStep === "2.1" && (
								<S.BtnCont>
									<DefaultButton onClick={() => continueToNextStep()} className="button tiny-secondary-button" disabled={!isLoaded}>
										Pasar al siguiente paso
									</DefaultButton>
								</S.BtnCont>
							)}
						{savingsPlan?.configurationMapStep !== "2.1" && (
							<S.BtnCont>
								<DefaultButton onClick={() => redirectToMap()} className="button tiny-secondary-button" disabled={!isLoaded}>
									Volver al mapa
								</DefaultButton>
							</S.BtnCont>
						)}
					</S.MainCont>
				</S.Cont>
				
				<ModalWithCancel
					showModal={showDeleteModal}
					setShowModal={setShowDeleteModal}
					title="Confirmación de eliminación"
					body={`¿Estás seguro de que deseas eliminar al interviniente ${deleteUserName}?`}
					btnSubmitText="Eliminar"
					onSubmit={() => deleteAccountHolder(deleteId!)}
				/>

				{showRequestAuthorizationModal && (<ModalRequestAuthorization
					userId={user.id}
					showModal={showRequestAuthorizationModal}
					userIdentitiesAccessRequest={userIdentitiesAccessRequest}
					selectedUserIdentity={selectedUserIdentity!}
					handleSubmit={(signatureSuccess) => {
						setShowRequestAuthorizationModal(false);
						if (signatureSuccess) {

						}
					}}

				></ModalRequestAuthorization>)}
			</React.Fragment>
		</DocumentTitle>
	);
};

export default ConvenienceTestAccountHolder;
